import _ from "lodash";
import { put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  getTemplateDefaultCallViewAPI,
  updateTemplateCallViewAPI,
} from "redux/api/callViewAPI";
import {
  getTemplateDefaultCallView,
  getTemplateDefaultCallViewSuccess,
  getTemplateVideoCallSuccess,
  updateTemplateCallView,
} from "redux/slices/callView";
import { Notification } from "components/Notification/Noti";

export default function* callViewSaga() {
  yield takeEvery(
    getTemplateDefaultCallView.type,
    getTemplateDefaultCallViewSaga
  );
  yield takeLatest(updateTemplateCallView.type, updateTemplateCallViewSaga);
}

function* getTemplateDefaultCallViewSaga(action) {
  try {
    const response = yield getTemplateDefaultCallViewAPI({
      object_id: _.get(action, "payload.object_id"),
      template: _.get(action, "payload.template"),
    });
    if (_.get(action, "payload.template")) {
      if (!Array.isArray(_.get(response, "data.data"))) {
        yield put(getTemplateVideoCallSuccess(_.get(response, "data.data")));
      }
    } else {
      yield put(
        getTemplateDefaultCallViewSuccess(_.get(response, "data.data"))
      );
    }
    if (_.get(action, "payload.isUpdate")) {
      Notification("success", "Update successfully!");
    }
  } catch (error) {
    console.log(error);
  }
}

function* updateTemplateCallViewSaga(action) {
  try {
    yield updateTemplateCallViewAPI(action.payload);
    yield put(
      getTemplateDefaultCallView({
        object_id: "obj_contact_00000001",
        isUpdate: true,
        template: action.payload.is_video_call ? "3" : undefined,
      })
    );
  } catch (error) {
    Notification("error", error);
  }
}
